import { Module, VuexModule, Action, Mutation } from "vuex-module-decorators";
import { RootState } from "@/store";
import { queryRequest } from "@/utils/request";
import { tbrLogin } from "@/graphql/login.gql";
import { queryK1Store } from "@/graphql/account.gql";

export interface UserState {
  k1Name: string;
}

@Module({ name: "UserModule", namespaced: true })
export default class UserModule
  extends VuexModule<UserState, RootState>
  implements UserState {
  public k1Name: string = "";

  @Mutation
  saveK1NameMutation(data: string) {
    this.k1Name = data ?? "";
  }

  // 登录
  @Action
  async login(form: any) {
    const userInfo = await queryRequest({
      query: tbrLogin,
      variables: {
        ...form
      }
    });
    console.log(31, userInfo);
    if (userInfo) {
      localStorage.setItem("token", userInfo.userAuthToken);
    }
  }

  @Action
  async queryK1StoreAction() {
    const name = await queryRequest({
      query: queryK1Store
    });
    this.context.commit("saveK1NameMutation", name);
  }
}
